import { useSecuritiesContext } from '../contexts';
import type { Security } from '../types/Security';

export const useSecurity = (symbol?: string | null): Security | undefined => {
  const { securitiesBySymbol } = useSecuritiesContext();
  if (symbol != null && securitiesBySymbol != null) {
    return securitiesBySymbol.get(symbol);
  }
};
